import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { COMMAND_STORAGE_KEY } from './constants';

export const storage = createSessionStorageProvider('use-local-storage-command');
